import type { FC } from "react";
import { InstallOnChrome } from "@/features/installOnChrome";
import type { IComponentBaseProps } from "@/shared/config";
import { useCN } from "@/shared/lib/hooks";
import type { ICta } from "../config";
import wave from "/assets/images/banner-wave.svg";
import "./../style.pcss";

interface ICtaProps extends ICta, IComponentBaseProps {}

/**
 * Компонент Call to Action
 * Отображает секцию с призывом к действию
 *
 * @param {ICta & IComponentBaseProps} props - свойства компонента
 * @returns {ReactNode} JSX-разметка блока
 */
export const Cta: FC<ICtaProps> = ({
  title,
  subtitle,
  baseClass = "cta",
  extraClasses = "",
  extraAttrs = {},
}) => {
  const { getCN } = useCN(baseClass);

  return (
    <section
      className={getCN("", {}, [ `mobile:max-w-100 mx-auto ${extraClasses ?? ""}` ])}
      {...extraAttrs}
    >
      <div className={getCN("inner")}>
        <div className={"flex flex-col gap-6 mobile:gap-3"}>
          <h2 className={getCN("title", {}, [ "text-center h2" ])}>{title}</h2>
          <p className={getCN("description", {}, [ "text-center subtitle text-cherrywood" ])}>{subtitle}</p>
        </div>
        <div className={getCN("action", {}, [ "w-full" ])}>
          <InstallOnChrome />
        </div>
        <img
          src={wave}
          alt={"decorative wave"}
          className={"absolute bottom-[-6.25rem] tablet:bottom-0 left-0 w-full h-auto pointer-events-none mobile:!hidden"}
        />
      </div>
    </section>
  );
};
